export function objectBooleanToString(values, toBooleanValues) {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => {
      if (toBooleanValues.includes(key)) {
        if (value) {
          return [key, 'yes'];
        }
        return [key, 'no'];
      }
      return [key, value];
    })
  );
}
